export interface Review {
  id: string;
  username: string;
  avatarInitial: string;
  rating: number;
  content: string;
  date: string;
  source: string;
}

export const reviews: Review[] = [
  {
    id: 'review-1',
    username: '星之轨迹',
    avatarInitial: '星',
    rating: 5,
    content: '这个galgame资源网站导航太实用了！之前找汉化补丁总是东奔西跑，现在直接在这里就能找到最全的galgame资源网站，省了好多时间。特别感谢整理者！',
    date: '2024-12-18',
    source: '绯月Galgame',
  },
  {
    id: 'review-2',
    username: '樱吹雪',
    avatarInitial: '樱',
    rating: 5,
    content: '作为刚入坑的galgame新手，这个网站的攻略指南部分帮了我大忙。从下载到安装到汉化，每一步都有详细的教程，让我少走了很多弯路。强烈推荐给所有galgame新人！',
    date: '2024-12-10',
    source: '月幕Galgame',
  },
  {
    id: 'review-3',
    username: '深夜读书人',
    avatarInitial: '深',
    rating: 5,
    content: '分类清晰，更新及时，基本上我想找的galgame资源网站这里都有收录。特别是汉化资源网站那一栏，让我发现了几个之前不知道的宝藏汉化组。',
    date: '2024-11-28',
    source: '星空论坛',
  },
  {
    id: 'review-4',
    username: '月下独酌',
    avatarInitial: '月',
    rating: 4,
    content: '非常全面的galgame资源整合站，推荐的功能很实用。建议可以增加一个"最新汉化发布"的实时追踪栏目，这样就能第一时间知道有哪些新汉化出来了。',
    date: '2024-11-20',
    source: 'Galgame情报局',
  },
  {
    id: 'review-5',
    username: '春日野穹',
    avatarInitial: '春',
    rating: 5,
    content: '从galgame免费下载网站到攻略社区，这个导航站把galgame玩家需要的所有资源都整合在了一起。UI设计也很清爽，查找起来非常方便。已经成为我的浏览器首页了！',
    date: '2024-11-12',
    source: '绯月Galgame',
  },
  {
    id: 'review-6',
    username: '风见幽香',
    avatarInitial: '风',
    rating: 5,
    content: '攻略Wiki的收录让我惊艳到了，居然连一些冷门老作的攻略都有。对于我这种喜欢挖老游戏的玩家来说简直是福音。文章区的攻略教程也写得很专业。',
    date: '2024-10-30',
    source: 'Galgame攻略Wiki',
  },
  {
    id: 'review-7',
    username: '十六夜咲夜',
    avatarInitial: '十',
    rating: 5,
    content: '日系galgame资源的整合做得非常好，从Key社到柚子社，从新作到经典，各种类型的galgame资源网站都有涉及。收藏了，以后找资源就靠它了！',
    date: '2024-10-18',
    source: '星空论坛',
  },
  {
    id: 'review-8',
    username: '博丽灵梦',
    avatarInitial: '博',
    rating: 4,
    content: '整体来说非常好用的galgame资源导航，分类方式很合理。希望后续能增加更多独立galgame和同人作品的资源推荐，这些作品的资源往往更难找。',
    date: '2024-10-05',
    source: '琉璃神社',
  },
];